const wordsForSimple = ["Simple", "Intuitive", "Affordable", "Simple and affordable", "Easy and affordable", "Modern"];

const wordsForEveryFarmer = [
    "every farmer",
    "every grower",
    "growers",
    "farmers",
    "every farmer on the planet",
    "every farmer in andromeda",
    "just Paul",
];

const wordsForIrrigation = ["irrigation automation", "automation", "irrigation control"];

const punctationBeforeFinally = [".", ",", "..."];

const punctationNoFinally = [".", "!", ""];

const verdiGreens = ["#67b700", "#8bc34a", "#8ebe50", "#89c422", "#68b801"];

const fontStyleProps = [
    {
        fontFamily: `"Century Gothic", "Roboto","Helvetica","Arial",sans-serif`,
        fontWeight: 900,
    },
    {
        fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
        fontWeight: 600,
    },
    {
        fontFamily: `"Poppins", "Roboto","Helvetica","Arial",sans-serif`,
        fontWeight: 600,
    },
];
export const getRandomFontProps = () => pickWordFromList(fontStyleProps);

const pickWordFromList = (list: any[]) => list[Math.floor(Math.random() * list.length)];

export const getRandomSlogan = () => {
    let base = `${pickWordFromList(wordsForSimple)} ${pickWordFromList(wordsForIrrigation)} for ${pickWordFromList(wordsForEveryFarmer)}`;

    if (Math.random() > 0.1) {
        base += pickWordFromList(punctationBeforeFinally);
        const Finally = Math.random() > 0.5 ? "...Finally" : "Finally";
        return (
            <>
                {base}
                <br />
                <br />
                <br />
                <span
                    style={{
                        animationName: "mission-fade-in",
                        animationDuration: "700ms",
                        animationDelay: "1400ms",
                        animationFillMode: "both",
                    }}
                >
                    {Finally}
                </span>
            </>
        );
    }

    base += `${pickWordFromList(punctationNoFinally)}`;
    return <>{base}</>;
};

export const getRandomGreen = () => pickWordFromList(verdiGreens);
